module.exports = {
      id: "quality-usage",
      viewBox: "0 0 22.3 30",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#quality-usage",
      toString: function () {
        return this.url;
      }
    }